import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
	MatterRequisitionPrecedentStatuses,
	requisitionStatuses,
} from '@models/requisitions';
import {
	DropdownOption,
	DropdownResult,
} from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { TestHooks } from './requisition-status-dropdown.hooks';

@Component({
	selector: 'app-requisition-status-dropdown',
	templateUrl: './requisition-status-dropdown.component.html',
	standalone: false,
})
export class RequisitionStatusDropdownComponent {
	testHooks = TestHooks;
	public requisitionStatuses = requisitionStatuses;

	public selectedRequisitionStatus: MatterRequisitionPrecedentStatuses;
	public selectedRequisitionStatusName: string;

	@Input() set status(status: MatterRequisitionPrecedentStatuses) {
		this.selectedRequisitionStatus = status;
		this.selectedRequisitionStatusName = this.requisitionStatuses.find(
			(_status) => _status.value === status,
		)?.name;
	}

	@Output() statusChange =
		new EventEmitter<MatterRequisitionPrecedentStatuses>();

	onSelectRequisitionStatus(
		status: DropdownResult<DropdownOption<MatterRequisitionPrecedentStatuses>>,
	) {
		this.status = status.result.value;
		this.statusChange.emit(status.result.value);
	}
}
